<template>
  <div class="accommodations-content-main">
    <div class="accommodations-list">
      <div
        class="accommodations-list-item"
        v-for="(item, index) in accommodationsList"
        :key="item.id"
        :ref="'isVisibleItem' + index"
      >
        <div class="left" :class="{'animateX': isVisible[index]}">
          <img loading="lazy" :class="{'banner-fade-in':isVisible[index]}"  :src="item.img" alt="" />
        </div>
        <div class="right" :class="{'animateRight': isVisible[index]}">
          <div class="lable"><span>——</span>{{ item.lable }}</div>
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="trip-content">
      <div class="trip-content-center" ref="tripContent" :class="{'banner-fade-in':isAnimate}">
        <div class="trip-content-title" :class="{'animate':isAnimate}">Find your trip</div>
        <div class="bottom" @click="goTripEvent" :class="{'animate':isAnimate}">
          <div class="btn">Explore Trips</div>
          <img loading="lazy"  src="../../../static/img/home/back.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import accommodations from '/js/experience/accommodations/accommodations.js';

export default {
  data() {
    return {
      accommodationsList: accommodations.accommodationsList,
      isAnimate:false,
      isVisible:[]
    };
  },
  mounted() {
      this.accommodationsList.forEach((_, index) => {
          const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
              if (entry.isIntersecting) {
              // 设置当前元素为可见
              this.$set(this.isVisible, index, true);
              observer.unobserve(entry.target); // 停止观察该元素
              }
          });
          }, { threshold: 0.1 });

          // 获取当前索引的元素并开始观察
          const element = this.$refs['isVisibleItem' + index][0];
          observer.observe(element);
      });
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isAnimate = true;
          }
        });
      }, { threshold: 0.1 });
      observer.observe(this.$refs.tripContent);
  },
  methods: {
      goTripEvent() {
        this.$router.push('/travel');
      },
  },
};
</script>

<style scoped lang="scss">
@import '/style/pc/experience/accommodations.scss';
@import '/style/phone/experience/accommodations/accommodations.scss';
@import '/style/pc/common/fadeIn.scss';
@import '/style/pc/common/animate.scss';
@import '/style/pc/common/animateX.scss';
@import '/style/pc/common/animateRight.scss';
</style>
